interface BackendSystem {
  id: string
  code?: string | null
  enable?: boolean | null
}

/** The backend system a Systemfinder category may link to: matched by code and enabled (STO-61). */
export function linkableConfiguratorSystem<T extends BackendSystem> (
  configuratorCode: string | null | undefined,
  systems: T[] | undefined
): T | undefined {
  if (!configuratorCode) return undefined
  const system = systems?.find((s) => s.code === configuratorCode)
  return system?.id && system.enable ? system : undefined
}
